import AutomationNewLayout from './AutomationNewLayout';

/**
 * Automation New — full Socket.IO integration with qa-path-automation-agent.
 * Route: /home/projects/:project_id/automation_new
 */
export default function AutomationNew() {
  return <AutomationNewLayout />;
}
